import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledSectionSubtitle = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  padding: '0',
  gap: '24px',
  width: '-webkit-fill-available',
  paddingLeft: '$6',
  paddingRight: '$6',
});

export const StyledBoxSubtitle = styled(Box, {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px 32px',
  gap: '10px',
  width: '-webkit-fill-available',
  height: '103px',
  background: '#FFFFFF',
  border: '1px solid #E8EDEF',
  borderRadius: '8px',
});

export const StyledSubtitle = styled(Box, {
  color: '$darkBlue300',
  display: 'flex',
  fontSize: '$2xl',
});

export const StyledSubtitleLabel = styled('label', {
  fontStyle: 'normal',
  fontWeight: '620',
  fontSize: '14px',
  lineHeight: '16px',
  display: 'flex',
  alignItems: 'flex-end',
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: '#323D5F',
});

export const StyledSubtitleLabelSection = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '0px',
  margin: '0 auto',
});

export const StyledSubtitleLabel2 = styled('label', {
  fontStyle: 'italic',
  fontWeight: '300',
});

export const StyledSubtitleNumber = styled('label', {
  margin: '0 auto',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '48px',
  lineHeight: '56px',
  leadingTrim: 'both',
  textEdge: 'cap',
  display: 'flex',
  alignItems: 'flex-end',
  color: '#3F4C77',
  fontStretch: '100',
});
